import { Stack } from 'expo-router';
import { colors } from '../../../src/theme/colors';

export const unstable_settings = {
  initialRouteName: 'index',
};

// Opaque app-base color so screens hide the inactive (mounted) tabs (no bleed)
// and blend with the chrome instead of reading as a separate container.
const contentBackground = colors.background.primary;

export default function VoiceAgentsStackLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: contentBackground },
      }}
    />
  );
}
